// Chuyển URL Firebase sang CDN (đổi host, bỏ /v0/b) cho ảnh/video đã upload
export const rewriteToCdn = (url?: string | null) => {
  if (!url) return '';
  try {
    const parsed = new URL(url);
    // Nếu đã là CDN hoặc host khác, giữ nguyên
    if (parsed.hostname === 'mphoto.mphotovn.online') return url;

    const segments = parsed.pathname.split('/').filter(Boolean); // v0/b/<bucket>/o/<object>
    const bIdx = segments.indexOf('b');
    const oIdx = segments.indexOf('o');

    if (bIdx !== -1 && oIdx !== -1 && oIdx + 1 < segments.length) {
      const bucket = segments[bIdx + 1];
      const objectPath = segments.slice(oIdx + 1).join('/'); // đã encode
      parsed.hostname = 'mphoto.mphotovn.online';
      parsed.pathname = `/${bucket}/${objectPath}`;
      return parsed.toString();
    }

    return url;
  } catch {
    return url;
  }
};

